import { render, staticRenderFns } from "./PatientCard.vue?vue&type=template&id=f61aced6&scoped=true&"
import script from "./PatientCard.vue?vue&type=script&lang=js&"
export * from "./PatientCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientCard.vue?vue&type=style&index=0&id=f61aced6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61aced6",
  null
  
)

export default component.exports